// extracted by mini-css-extract-plugin
module.exports = {"root":"_07eca1","paragraph":"_413730","faded":"_e5c64f","ratingAlignment":"_ddf8e3","ratingCenterAlignment":"_5406de"};